import { useState, useContext } from "react";
import { ClientPortfolioFilter } from "../fragments.dispatches/ClientPortfolioFilter";
import { ClientPortfolioList } from "../fragments.dispatches/ClientPortfolioList";
import { ContextAuth } from "../../../contexts/ContextAuth";
import { getCurrentDate } from "../../../configs/helpers";

const currentDate  = new Date();
const initialDate  = new Date(currentDate.getFullYear(), 0);
const finalMonth   = initialDate.getMonth() + 2;
const finalYear    = initialDate.getFullYear() + Math.floor(finalMonth / 12);
const finalDate    = new Date(finalYear, finalMonth % 12, initialDate.getDate());

export function ClientPortfolioPage() {
    const [orders, setOrders] = useState([]);
    const { auth } = useContext(ContextAuth);

    const [questionState, setQuestionState] = useState({
        startDate:       getCurrentDate("-"),
        endDate:         getCurrentDate("-"),
        subsidiaryID:    auth.data.subsidiary.subsidiary_id,
        warehouseID:     0,
        gangID:          0,
        userID:          0,
        operationStatus: "02",
        startMonth:      Number(initialDate.getMonth()),
        endMonth:        Number(finalDate.getMonth()),
        startYear:       Number(initialDate.getFullYear()),
        endYear:         Number(finalDate.getFullYear()),
        monthToCompare:  4,
    });

    return (
        <>
            {/* Page header */}
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                            Cartera de clientes
                        </h1>
                        <nav aria-label="breadcrumb">
                            <ol className="flex items-center gap-2 text-sm">
                                <li className="text-blue-600 dark:text-blue-400">Reportes</li>
                                <li className="text-gray-400 dark:text-gray-500 select-none">/</li>
                                <li className="text-gray-700 dark:text-gray-300 font-medium">Cartera de clientes</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            <section>
                <div className="max-w-full px-4 space-y-4">
                    <ClientPortfolioFilter
                        setQuestionState={setQuestionState}
                        questionState={questionState}
                        setOrders={setOrders}
                    />
                    <ClientPortfolioList orders={orders} />
                </div>
            </section>
        </>
    );
}
